import { useState, useEffect, useCallback } from 'react';

type TourPage = 'home' | 'assignments' | 'tracking' | null;

const COMPLETED_KEY = 'driver_onboarding_completed_v1';
const PAGE_KEY = 'driver_onboarding_page';

function getStoredPage(): TourPage {
  const val = localStorage.getItem(PAGE_KEY);
  if (val === 'home' || val === 'assignments' || val === 'tracking') return val;
  return null;
}

export function useDriverOnboarding(pageId: TourPage) {
  const [showTour, setShowTour] = useState(false);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const completed = localStorage.getItem(COMPLETED_KEY) === 'true';
    const currentPage = getStoredPage();

    if (!completed && !currentPage) {
      localStorage.setItem(PAGE_KEY, 'home');
      setShowTour(pageId === 'home');
    } else if (currentPage === pageId) {
      setShowTour(true);
    }

    setInitialized(true);
  }, [pageId]);

  const finishTour = useCallback(() => {
    localStorage.removeItem(PAGE_KEY);
    localStorage.setItem(COMPLETED_KEY, 'true');
    setShowTour(false);
  }, []);

  const advanceTour = useCallback((nextPage: TourPage) => {
    if (nextPage) {
      localStorage.setItem(PAGE_KEY, nextPage);
    } else {
      localStorage.removeItem(PAGE_KEY);
      localStorage.setItem(COMPLETED_KEY, 'true');
    }
    setShowTour(false);
  }, []);

  const skipTour = useCallback(() => {
    advanceTour(null);
  }, [advanceTour]);

  const resetTour = useCallback(() => {
    localStorage.removeItem(COMPLETED_KEY);
    localStorage.setItem(PAGE_KEY, 'home');
  }, []);

  return { showTour, initialized, finishTour, advanceTour, skipTour, resetTour };
}
